<template>
    <div class="diagram  row-center">
        <div class="box">
            <div class="title row-center">
                <span>用电趋势</span>
                <div class="tag">
                    <label :class="{ active: range == 'hour' }" @click="range = 'hour'">日</label>
                    <label :class="{ active: range == 'day' }" @click="range = 'day'">月</label>
                    <label :class="{ active: range == 'month' }" @click="range = 'month'">年</label>
                </div>
            </div>
            <div class="cont">
                <Charts id="chartOption1" :option="chartOption1"></Charts>
            </div>
        </div>
        <div class="box">
            <div class="title  row-center">
                <span>分项用电</span>
                <div class="tag">
                    <label :class="{ active: range1 == 'day' }" @click="range1 = 'day'">日</label>
                    <label :class="{ active: range1 == 'month' }" @click="range1 = 'month'">月</label>
                    <label :class="{ active: range1 == 'year' }" @click="range1 = 'year'">年</label>
                </div>
            </div>
            <div class="cont">
                <Charts id="chartOption2" :option="chartOption2"></Charts>
            </div>
        </div>
    </div>
</template>
<script>
import Charts from "../../../components/common/Charts.vue";
import { eymAreaReport,eymitemEnergyConsumption } from '../../../api/power'
import * as echarts from 'echarts';
import { subscribe } from '../../../mqtt/index'
import { dayStart, dayEnd } from '../../../util/DateUtil'
export default {
    props: ['allTransformers'],
    data() {
        return {
            range: "hour",
            range1:"day",
            usrPower: [],
            sevenDay: [],
            SubdivisionalList:{
                xAxis:[],
                series:[]
            }
        };
    },
    components: {
        Charts
    },
    computed: {
        chartOption1() {
            return {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    textStyle: {
                        color: "#333333" //设置文字颜色
                    },
                    formatter: function (params) {
                        let str = `${params[0].name}<br/>`;
                        params.forEach((item, idx) => {
                            str += `${item.marker}用电量： <b style='font-size:18px;'>${item.value}</b><b style='font-size:14px;'> kWh</b>`;
                            str += idx === params.length - 1 ? '' : '<br/>'
                        })
                        return str
                    }
                },
                xAxis: {
                    type: 'category',
                    axisTick: {
                        show: false
                    },
                    data: this.sevenDay,
                    axisLabel: {
                        fontSize: 12,
                        color: "#333",
                        fontWeight: 'bold'
                    },
                },
                grid: {
                    left: "0%",
                    right: "3%",
                    bottom: "0%",
                    top: "10%",
                    containLabel: true,
                },
                yAxis: {
                    type: 'value',
                    // name:'kWh',
                    nameTextStyle: {
                        align: "right",
                        fontWeight: 'bold',
                        fontStyle: "italic",
                        // fontSize: 16,
                        color: "#333",
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed',
                        }
                    },
                    axisLabel: {
                        fontSize: 12,
                        color: "#333",
                        fontWeight: 'bold'
                    }
                },
                series: [
                    {
                        data: this.usrPower,
                        type: 'line',
                        smooth: true
                    }
                ]
            };
        },
        chartOption2() {
            return {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: function (params) {
                        let str = `${params[0].name}<br/>`;
                        params.forEach((item, idx) => {
                            str += `${item.marker}用电： <b style='font-size:18px;'>${item.value}</b><b style='font-size:14px;'> kWh</b>`;
                            str += idx === params.length - 1 ? '' : '<br/>'
                        })
                        return str
                    }
                },
                xAxis: {
                    type: 'category',
                    axisTick: {
                        show: false
                    },
                    data: this.SubdivisionalList.xAxis,
                    axisLabel: {
                        fontSize: 12,
                        color: "#333",
                        fontWeight: 'bold'
                    },
                },
                grid: {
                    left: "0%",
                    right: "3%",
                    bottom: "0%",
                    top: "10%",
                    containLabel: true,
                },
                yAxis: {
                    type: 'value',
                    // name:'kWh',
                    nameTextStyle: {
                        align: "right",
                        fontWeight: 'bold',
                        fontStyle: "italic",
                        // fontSize: 16,
                        color: "#333",
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed',
                        }
                    },
                    axisLabel: {
                        fontSize: 12,
                        color: "#333",
                        fontWeight: 'bold'
                    }
                },
                series: [
                    {
                        data: this.SubdivisionalList.series,
                        type: 'bar'
                    }
                ]
            };
        },
        mqttval() {
            return this.getMqttVal(this.$store.getters.mqttVal);
        },
        projectId() {
            return this.$store.getters.projectId
        }
    },
    watch: {
        '$store.getters.areaId'() {
            this.initData()
            this.Subdivisional();
        },
        range(n, o) {
            switch (n) {
                case 'hour':
                    this.sevenDay = []
                    for (let i = 0; i <= 24; i++) {
                        this.sevenDay.push(i + "点");
                    }
                    this.range1 = "day"
                    this.initData()
                    break;
                case 'day':
                    this.sevenDay = []
                    for (let i = 1; i <= 31; i++) {
                        this.sevenDay.push(i + "日");
                    }
                    this.range1 = "month"
                    this.initData()
                    break;
                case 'month':
                    this.sevenDay = []
                    for (let i = 1; i <= 12; i++) {
                        this.sevenDay.push(i + "月");
                    }
                    this.range1 = "year"
                    this.initData()
                    break;
                default:
                    break;
            }
        },
        range1(n,o){
            this.Subdivisional();
            switch (n) {
                case 'day':
                    this.range = "hour"
                    break;
                case 'month':
                    this.range = "day"
                    break;
                case 'year':
                    this.range = "month"
                    break;
                default:
                    break;
            }
        }
    },
    mounted() {

        this.sevenDay = []
        for (let i = 0; i <= 24; i++) {
            this.sevenDay.push(i + "点");
        }
        this.initData();
        this.Subdivisional();
    },
    destroyed() {

    },
    methods: {
        async initData() {
            let date = dayStart(new Date()).split('T')[0]
            let obj = {
                date: date,
                // projectId: this.projectId,
                range: this.range,
                // reportType: "use",
                areaId:this.$store.getters.areaId
            }
            let response = await eymAreaReport(obj);
            this.usrPower = response.data.data || [];
        },
        async Subdivisional() {
            let date = dayStart(new Date())
            let obj = {
                areaId:this.$store.getters.areaId,
                projectId: this.projectId,
                date: date,
                range: this.range1.toUpperCase(),
                itemType: ""
            }
            let response = await eymitemEnergyConsumption(obj);
            this.SubdivisionalList = {
                xAxis:[],
                series:[]
            }
            
            for(let i in response.data.data.result){
                this.SubdivisionalList.xAxis.push(i)
                this.SubdivisionalList.series.push(response.data.data.result[i].toFixed(2))
            }
            // this.SubdivisionalList = response.data.result || [];

        },
    }
};
</script>
<style lang="less" scoped>
.diagram {
    height: 100%;
    justify-content: space-between;

    .box {
        background: #ffffff;
        .w(592);
        height: 100%;
        padding: 18rem;
    }

    .title {
        font-size: 16rem;
        font-weight: bold;
        margin-bottom: 10rem;
        justify-content: space-between;
        position: relative;

        .tag {
            label {
                color: #333;
                cursor: pointer;
                margin-left: 12px;
                position: relative;
            }

            .active {
                color: #0E9CFF;
            }

            .active::before {
                content: "";
                border-top: 2px solid #0E9CFF;
                position: absolute;
                top: -22rem;
                width: 100%;
            }
        }
    }

    .el-dropdown {
        color: #333;
        float: right;
        font-weight: 400;
        cursor: pointer;

        .el-dropdown-link {
            i {
                font-size: 24rem;
                vertical-align: middle;
            }
        }
    }

    .cont {
        justify-content: space-between;
        .h(250);
        width: 100%;
        position: relative;

        .nothing {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 55%;
            height: 60%;
            background: url('../../../assets/img/not_found_data.png') no-repeat;
            background-size: 100% 100%;
        }
    }
}
</style>